import { render, staticRenderFns } from "./showBarcode.vue?vue&type=template&id=401bc16b"
import script from "./showBarcode.vue?vue&type=script&lang=js"
export * from "./showBarcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports